<h2 mat-dialog-title>Alert</h2>
<p mat-dialog-content>{{data.description}}</p>
<div mat-dialog-actions>
  <button mat-raised-button [appThemedButton]="data.theme" mat-dialog-close>Close</button>
</div>
